import {AfterContentInit, AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import { language} from '../../../language/vn';
import {UploaderComponent, RemovingEventArgs } from '@syncfusion/ej2-angular-inputs';
import {EmitType} from '@syncfusion/ej2-base';
import { SelectedEventArgs } from '@syncfusion/ej2-angular-inputs';
import {environment} from '../../../../environments/environment';
import {element} from 'protractor';

@Component({
  selector: 'ui-upload-file',
  templateUrl: './uploadfile.component.html',
  encapsulation: ViewEncapsulation.None
})
export class UploadFileComponent  implements  OnInit, AfterViewInit, OnDestroy {
  @ViewChild('uploadFileComponent')
  public uploadCommand: UploaderComponent;
  public dropElement: HTMLElement;
  public buttons = { browse: language.uploadfile, clear: language.deleteall, upload: "" };
  @Input() uploadUrl: String;
  @Input() deleteUrl: String;
  @Input() deleteStatus: boolean = true;
  public id: number;
  public path: Object ;
  @Input() autoUpload: boolean;
  @Input() dropZone: string;
  @Input() dataFiles: Object[];
  public idview: number;

  ngOnInit(): void {
    this.path = {
      saveUrl: this.uploadUrl,
      removeUrl: this.deleteUrl
    };
    this.dropElement = document.getElementById(this.dropZone);
    /*this.idview = setInterval(() => {
      this.reloadFile();
    }, 1000);*/
    setTimeout (() => {
      this.reloadFile();
    }, 2000);
  }
  ngAfterViewInit() {
    let elementDropName = document.querySelectorAll('.e-file-drop');
    if (elementDropName.length > 0)
      elementDropName[0].innerHTML = language.dropfileupload;
  }
  ngOnDestroy() {
   /*if (this.idview) {
      clearInterval(this.idview);
    }*/
  }
  public reloadFile()
  {
    if (this.idview && this.dataFiles!=null) {
      clearInterval(this.idview);
    }
    let deleteAllElement=document.querySelectorAll('.e-upload-actions');
    if(deleteAllElement.length>0)
      deleteAllElement[0].setAttribute("style","display:none");
    let elements =  document.querySelectorAll('.e-file-name');
    let elementsLoad =  document.querySelectorAll('.e-file-status');

    let elementsDelete= document.querySelectorAll('.e-file-delete-btn');
    for(let i = 0; i < elements.length;i++)
    {
      elements[i].innerHTML= this.dataFiles[i]["title"] + ` <a href="${environment.downloadURL}file=${this.dataFiles[i]["folder"]}${this.dataFiles[i]["name"]}&type=${this.dataFiles[i]["fileType"]}&title=${this.dataFiles[i]["title"]}"><i class="fa fa-download"></i></a>`;
      elementsLoad[i].innerHTML= "";
      if(this.deleteStatus === false)
        elementsDelete[i].setAttribute("style","display:none");
    }

  }
  public onFileSelect: EmitType<Object> = (args: any) => {
    setTimeout (() => {
      let elements =  document.querySelectorAll('.e-file-name');
      let elementTypes =  document.querySelectorAll('.e-file-type');

      for(let i=0; i< this.uploadCommand.getFilesData().length;i++)
      {
        let path : string =(window.URL || window.webkitURL).createObjectURL(this.uploadCommand.getFilesData()[i].rawFile);
        elements[i].innerHTML = '<a href="' + path + '" target="_blank">' + this.uploadCommand.getFilesData()[i].id.replace(this.uploadCommand.getFilesData()[i].type, '') + '</a>';
        elementTypes[i].innerHTML = '<a href="' + path + '" target="_blank">' + this.uploadCommand.getFilesData()[i].type + '</a>';
      }

    }, 2000);

  }

  public onFileUpload(args: any)  {
    args.currentRequest.setRequestHeader('Authorization', "Bearer "+ sessionStorage.getItem('token'));
    args.customFormData = [{'id':this.id}];
  }
  public onRemoveFile: EmitType<SelectedEventArgs> = (args: any) =>  {
    args.currentRequest.setRequestHeader('Authorization', "Bearer "+ sessionStorage.getItem('token'));
  }
}
